var _defs, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackgroundLandingpageDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 3840 2160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7babaf;}.cls-2{fill:#87b3b4;}.cls-3{fill:#93bbbd;}.cls-4{fill:#9fc3c3;}.cls-5{fill:#abcacc;}.cls-6{fill:url(#Unbenannter_Verlauf_4);}.cls-7{fill:url(#Unbenannter_Verlauf_4-2);}.cls-8{fill:url(#Unbenannter_Verlauf_4-3);}.cls-9{fill:url(#Unbenannter_Verlauf_3);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_4",
    x1: 3771.02,
    y1: 1991.4,
    x2: 3778.07,
    y2: 1991.4,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2162)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#438989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deeced"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_4-2",
    x1: 3822.7,
    y1: 1939.8,
    x2: 3829.75,
    y2: 1939.8,
    xlinkHref: "#Unbenannter_Verlauf_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_4-3",
    x1: 3822.7,
    y1: 1991.4,
    x2: 3829.75,
    y2: 1991.4,
    xlinkHref: "#Unbenannter_Verlauf_4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_3",
    x1: 3694.82,
    y1: 229.77,
    x2: 3694.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#639d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#deeced"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 3671.2,
    cy: 377.3,
    r: 3.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3671.2,
    cy: 325.6,
    r: 3.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 3671.2,
    cy: 273.9,
    r: 3.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 3671.2,
    cy: 222.2,
    r: 3.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 3671.2,
    cy: 170.6,
    r: 3.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 3722.9,
    cy: 377.3,
    r: 3.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3722.9,
    cy: 325.6,
    r: 3.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 3722.9,
    cy: 273.9,
    r: 3.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 3722.9,
    cy: 222.2,
    r: 3.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 3722.9,
    cy: 170.6,
    r: 3.5
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 3774.5,
    cy: 377.3,
    r: 3.5
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3774.5,
    cy: 325.6,
    r: 3.5
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 3774.5,
    cy: 273.9,
    r: 3.5
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 3774.5,
    cy: 222.2,
    r: 3.5
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 3774.5,
    cy: 170.6,
    r: 3.5
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 3826.2,
    cy: 377.3,
    r: 3.5
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 3826.2,
    cy: 325.6,
    r: 3.5
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 3826.2,
    cy: 273.9,
    r: 3.5
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 3826.2,
    cy: 222.2,
    r: 3.5
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 3826.2,
    cy: 170.6,
    r: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M3665.3,0h-9.5c-10.2.1-19.5.1-28.1,0h-70.8a5.22,5.22,0,0,0-1.9,1.4c-8.7,8.9-6.1,29,2.8,41A21.13,21.13,0,0,0,3560,45c7,6.7,12.6,9.3,19.7,13.4,7.7,4.4,12.4,8.5,20.2,15.3A45.41,45.41,0,0,1,3610,85.5a36.58,36.58,0,0,1,2.9,6c2.1,5.5,2.3,10,4,16.2.5,1.6,12.7,36.8,40.3,47.6,11.7,4.6,17.9,1.6,33.7,1.3,11-.2,14.8.3,20.6,1.1a102,102,0,0,1,28.2,8.3c24.9,10.5,38,23.2,45.6,33.4a115,115,0,0,0,20.2,20.9s13.1,10.4,23,9.4a32,32,0,0,0,6.7-1.6,35.09,35.09,0,0,0,4.8-2.5V154.3L3839.6,0Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundLandingpageDesktop);
export default __webpack_public_path__ + "static/media/background_landingpage_desktop.2f73195b571422ca6fe09e7131e4f726.svg";
export { ForwardRef as ReactComponent };